export const queryKeys = {
  reallocations: ["reallocations"] as const,
  reallocationJobs: ["reallocationJobs"] as const,
};

export default queryKeys;
